import Vue from 'vue'
import auth from '@/auth'
import Router from 'vue-router'
import Login from '@/components/Login'
import UserIndex from '@/components/user/Index'
import ClientIndex from '@/components/client/Index'
import ProjectIndex from '@/components/project/Index'
import WorkOrderIndex from '@/components/workOrder/Index'
import WorkOrderHistory from '@/components/workOrder/History'
import WorkOrderAdminIndex from '@/components/workOrder/AdminIndex'
import LaborRegistryIndex from '@/components/laborRegistry/Index'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Landing',
      redirect: {name: 'WorkOrderIndex'}
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      beforeEnter: (to, from, next) => auth.loggedIn() ? next({name: 'Landing'}) : next()
    },
    {
      path: '/partes',
      name: 'WorkOrderIndex',
      component: WorkOrderIndex
    },
    {
      path: '/partes-administracion',
      name: 'WorkOrderAdminIndex',
      component: WorkOrderAdminIndex
    },
    {
      path: '/historico-de-partes',
      name: 'WorkOrderHistory',
      component: WorkOrderHistory
    },
    {
      path: '/operarios',
      name: 'UserIndex',
      component: UserIndex
    },
    {
      path: '/clientes',
      name: 'ClientIndex',
      component: ClientIndex
    },
    {
      path: '/proyectos',
      name: 'ProjectIndex',
      component: ProjectIndex
    },
    {
      path: '/registro-laboral',
      name: 'LaborRegistryIndex',
      component: LaborRegistryIndex
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.name !== 'Login' && !auth.loggedIn()) {
    return next({name: 'Login'})
  }
  return next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js